import React from "react";
import Modal from "../../../components/modal";

export const ViewClientsModal = ({ open, onClose, selectedGroup, linkedClients }) => {
    const clientLabel = linkedClients?.length === 1 ? "Client" : "Clients";

    return (
        <Modal
            cssClass="advanced-filters-modal"
            show={open}
            onClose={onClose}
        >
            <div className="flex-column p-16">
                <h2>SLA Group Name: {selectedGroup}</h2>
                <p className="txt-bold">
                    {linkedClients?.length} {clientLabel}
                </p>
                <div className="p-t-16 border-top flex-column">
                    {linkedClients?.map(({ clientName }) => (
                        <span key={clientName}>{clientName}</span>
                    ))}
                </div>
                <div className="button-group -center m-t-16 p-l-12">
                    <button
                        type="button"
                        className="button -primary"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};
